// スマホのシート（2026-10-21 に app.js から分けた）
import { txt } from './text.js';
import { $ } from './util.js';

// ---- スマホのシート（つまみを押すと広げる・戻す。引っぱってもよい） ----
// 全身のメーカー（.tall）のスマホ: 下に乗せた部品（重ね付けの切りかえ・パーツ・カテゴリの帯）の高さを --dock-h に（道具・元に戻す・名前などをその上に置く。style.css）。
// 大きさが変わるたびに測り直す（カテゴリで重ね付けの切りかえが出たり消えたり、パーツが1段だけのときなど）
function watchDock(app: HTMLElement) {
  const parts = ['layerPick', 'parts', 'cats'].map((id) => $(id));
  function measure() {
    const tops = parts.filter((n) => !n.hidden && n.offsetHeight > 0).map((n) => n.getBoundingClientRect().top);
    const h = tops.length ? app.getBoundingClientRect().bottom - Math.min.apply(null, tops) : 0;
    app.style.setProperty('--dock-h', Math.max(0, Math.round(h)) + 'px');
  }
  if (typeof ResizeObserver !== 'undefined') {
    const ro = new ResizeObserver(measure);
    parts.forEach((n) => { ro.observe(n); });
    ro.observe(app);
  }
  addEventListener('resize', measure);
  measure();
}
export function bindGrip() {
  var grip = $('grip'), app = $('app'), area = document.querySelector<HTMLElement>('.stage-area')!;
  var drag: { id: number; y: number; h: number; moved: boolean } | null = null, dragged = false;
  // CSS の --stage-h と同じ（作る画面の高さの、ふだん: 幅か 50% の小さいほう。広げたとき: 38%。全身のメーカー .tall のスマホはつまみを使わない）
  function limits() { const h = app.clientHeight; return { min: h * 0.38, max: Math.min(innerWidth, h * 0.5) }; }
  if (app.classList.contains('tall')) watchDock(app);
  function setExpanded(on: boolean) {
    app.classList.toggle('expanded', on);
    grip.setAttribute('aria-expanded', on ? 'true' : 'false');
    grip.setAttribute('aria-label', txt(on ? 'parts_close' : 'parts_open'));
  }
  grip.addEventListener('pointerdown', (e) => {
    drag = { id: e.pointerId, y: e.clientY, h: area.getBoundingClientRect().height, moved: false };
    grip.setPointerCapture(e.pointerId);
  });
  grip.addEventListener('pointermove', (e) => {
    if (!drag || drag.id !== e.pointerId) return;
    const dy = e.clientY - drag.y;
    if (!drag.moved && Math.abs(dy) < 6) return;
    drag.moved = true;
    app.classList.add('dragging');
    const lim = limits();
    app.style.setProperty('--stage-h', Math.max(lim.min, Math.min(lim.max, drag.h + dy)) + 'px');
  });
  function end(e: PointerEvent) {
    if (!drag || drag.id !== e.pointerId) return;
    if (drag.moved) {
      // 近いほうに寄せる（.dragging を外すのと同時なので、そこから動いて止まる）
      const lim = limits(), h = area.getBoundingClientRect().height;
      app.classList.remove('dragging');
      app.style.removeProperty('--stage-h');
      setExpanded(h < (lim.min + lim.max) / 2);
      dragged = true;
    }
    drag = null;
  }
  grip.addEventListener('pointerup', end);
  grip.addEventListener('pointercancel', end);
  grip.addEventListener('click', () => {
    if (dragged) { dragged = false; return; }
    setExpanded(!app.classList.contains('expanded'));
  });
}
